import { CommonModule } from '@angular/common';
import { Component, input, output, TemplateRef } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateGridViewActionsComponent } from '@data-access/grid-views';
import { WcgFilterIndicatorsOptions } from '@shared/interfaces/wcg-table-utils.interface';
import {
  GridViews,
  WcgAdvancedFilter,
  WcgAdvancedFiltersComponent,
  WcgFilterIndicatorsComponent,
} from '@wcg/frontend-framework';

@Component({
  selector: 'wcg-ui-filter-wrapper',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    WcgAdvancedFiltersComponent,
    WcgFilterIndicatorsComponent,
    CreateGridViewActionsComponent,
  ],
  templateUrl: './ui-filter-wrapper.component.html',
  styleUrl: './ui-filter-wrapper.component.css',
})
export class UiFilterWrapperComponent {
  readonly advancedFilters = input<WcgAdvancedFilter>();
  readonly appliedFilters = input<WcgAdvancedFilter>();
  readonly gridViewData = input<GridViews>();
  readonly advancedFiltersFormGroup = input<FormGroup>();

  readonly additionalFiltersTemplateRef = input<TemplateRef<unknown>>();

  applyFilters = output<WcgAdvancedFilter[]>();
  clearFilters = output<void>();
  revertGridState = output<void>();
  removeFilter = output<WcgFilterIndicatorsOptions>();
}
